import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAutenticacao } from './lib/auth';
import Login, { TelaCarregando } from './pages/Login';
import EsqueciSenha from './pages/EsqueciSenha';
import RedefinirSenha from './pages/RedefinirSenha';
import Painel from './pages/Painel';
import Quadro from './pages/Quadro';
import Quadros from './pages/Quadros';
import Agenda from './pages/Agenda';
import Escalas from './pages/Escalas';
import EscalaLideres from './pages/EscalaLideres';
import EscalaCultos from './pages/EscalaCultos';
import MinhasEscalas from './pages/MinhasEscalas';
import EscalaCulto from './pages/EscalaCulto';
import Equipe from './pages/Equipe';
import Logs from './pages/Logs';
import Financeiro from './pages/Financeiro';
import Palavras from './pages/Palavras';
import Fotos from './pages/Fotos';
import Cadastro from './pages/Cadastro';
import FormularioVisitante from './pages/FormularioVisitante';
import Equipes from './pages/Equipes';
import Placar from './pages/Placar';
import Visitantes from './pages/Visitantes';
import Aprovacoes from './pages/Aprovacoes';

function RotaProtegida({ children }: { children: React.ReactNode }) {
  const { usuario, carregando } = useAutenticacao();
  const local = useLocation();

  if (carregando) return <TelaCarregando />;
  // esconder no menu nao e protecao: o servidor tambem barra, isto aqui e so a tela
  if (!usuario) return <Navigate to="/login" replace state={{ de: local.pathname }} />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/cadastro" element={<Cadastro />} />
      <Route path="/formulario" element={<FormularioVisitante />} />
      <Route path="/esqueci-senha" element={<EsqueciSenha />} />
      <Route path="/redefinir-senha" element={<RedefinirSenha />} />
      <Route
        path="/painel"
        element={
          <RotaProtegida>
            <Painel />
          </RotaProtegida>
        }
      />
      <Route
        path="/quadros"
        element={
          <RotaProtegida>
            <Quadros />
          </RotaProtegida>
        }
      />
      <Route
        path="/quadro/:chave"
        element={
          <RotaProtegida>
            <Quadro />
          </RotaProtegida>
        }
      />
      <Route path="/quadro" element={<Navigate to="/quadros" replace />} />
      <Route
        path="/agenda"
        element={
          <RotaProtegida>
            <Agenda />
          </RotaProtegida>
        }
      />
      <Route
        path="/placar"
        element={
          <RotaProtegida>
            <Placar />
          </RotaProtegida>
        }
      />
      <Route
        path="/equipes"
        element={
          <RotaProtegida>
            <Equipes />
          </RotaProtegida>
        }
      />
      <Route
        path="/escalas"
        element={
          <RotaProtegida>
            <Escalas />
          </RotaProtegida>
        }
      />
      <Route
        path="/escala-lideres"
        element={
          <RotaProtegida>
            <EscalaLideres />
          </RotaProtegida>
        }
      />
      <Route
        path="/escala-cultos"
        element={
          <RotaProtegida>
            <EscalaCultos />
          </RotaProtegida>
        }
      />
      {/* a escala nasceu so para a Arena; o link antigo continua valendo */}
      <Route path="/escala-arena" element={<Navigate to="/escala-cultos" replace />} />
      <Route
        path="/minhas-escalas"
        element={
          <RotaProtegida>
            <MinhasEscalas />
          </RotaProtegida>
        }
      />
      <Route
        path="/equipe"
        element={
          <RotaProtegida>
            <Equipe />
          </RotaProtegida>
        }
      />
      <Route
        path="/visitantes"
        element={
          <RotaProtegida>
            <Visitantes />
          </RotaProtegida>
        }
      />
      <Route
        path="/aprovacoes"
        element={
          <RotaProtegida>
            <Aprovacoes />
          </RotaProtegida>
        }
      />
      <Route
        path="/financeiro"
        element={
          <RotaProtegida>
            <Financeiro />
          </RotaProtegida>
        }
      />
      <Route
        path="/logs"
        element={
          <RotaProtegida>
            <Logs />
          </RotaProtegida>
        }
      />
      <Route
        path="/palavras"
        element={
          <RotaProtegida>
            <Palavras />
          </RotaProtegida>
        }
      />
      <Route
        path="/fotos"
        element={
          <RotaProtegida>
            <Fotos />
          </RotaProtegida>
        }
      />
      <Route path="/membros" element={<Navigate to="/palavras" replace />} />
      <Route
        path="/culto/:id"
        element={
          <RotaProtegida>
            <EscalaCulto />
          </RotaProtegida>
        }
      />
      <Route path="*" element={<Navigate to="/painel" replace />} />
    </Routes>
  );
}
